import React, { FC } from 'react';
import { View } from 'react-native';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';

export interface AccordionTriggerIconCellProps {
  isExpanded: boolean;
  scale?: ScaleFunction;
  sequenceNumber?: number | string;
}

const AccordionTriggerIconCell: FC<AccordionTriggerIconCellProps> = ({
  isExpanded,
  scale = initialScale,
}) => {
  return (
    <View style={{
      zIndex: 10000000,
      transform: [{ rotate: isExpanded ? '90deg' : '0deg' }],
      marginLeft: scale(5)
    }}>
      <Svg
        icon="roundedChevron"
        width={scale(14)}
        height={scale(14)}
        color={isExpanded ? 'Link/Light/Primary' : 'Label/Light/Tertiary'}
      />
    </View>
  );
};

export default React.memo(AccordionTriggerIconCell, (prev, next) => {
  return (
    prev.sequenceNumber === next.sequenceNumber &&
    prev.isExpanded === next.isExpanded
  );
});
